export const moveForward = (currentStep, setCurrentStep, lastStep, setPreveStep) => {
  if (currentStep === lastStep) return setCurrentStep(0);
  else { return setCurrentStep((prevStep) => prevStep + 1), setPreveStep((prevStep) => prevStep + 1)}
};
